import { Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { LeafletGroupComponent } from "@components/leaflet/group/group.component";

import geojson from 'geojson';
import { GeoJSONToWKT, WKTToGeoJSON } from '@models';

@Component({
  selector: 'app-placename-search',
  imports: [
    ReactiveFormsModule,

    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatCardModule,
    MatSelectModule,

    LeafletGroupComponent,
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class PlacenameSearchComponent {
  dialogRef = inject<MatDialogRef<PlacenameSearchComponent>>(MatDialogRef);

  readonly data = inject<{
    search: string;
    location: string;
    status: string;
    area: string;
  }>(MAT_DIALOG_DATA);
  readonly geometry = WKTToGeoJSON(this.data?.location);

  form = new FormGroup({
    search: new FormControl(this.data?.search),
    location: new FormControl(this.data?.location),
    status: new FormControl(this.data?.status),
    area: new FormControl(this.data?.area),
  });

  onGeometryChange(data: geojson.FeatureCollection) {
    this.form.patchValue({ location: GeoJSONToWKT(data) });
    this.form.markAsDirty()
  }
}
